export const ACTIONS_EVENT = 'actions';

export const APPS_EVENT = 'apps';
